var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPhoneWhite = function SvgPhoneWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63.008,
    height: 63,
    viewBox: "0 0 63.008 63"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 1",
    d: "M62.727 50.217l-.312-.94a8.856 8.856 0 00-5.414-5.116l-8.28-2.261a8.111 8.111 0 00-7.094 1.852l-3 3a31.794 31.794 0 01-22.368-22.368l3-3a8.119 8.119 0 001.857-7.089l-2.258-8.283A8.845 8.845 0 0013.737.598l-.943-.317a7.52 7.52 0 00-7 1.651L1.315 6.417A8.331 8.331 0 00.002 9.499a52.912 52.912 0 0015.488 38 52.95 52.95 0 0037.888 15.493 8.349 8.349 0 003.22-1.3l4.479-4.482a7.513 7.513 0 001.646-7z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
};
export default SvgPhoneWhite;